import { useMemo } from "react";
import { Task } from "@common/types/task";
import { Button } from "@design-system/Button/Button";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import { useCommands } from "@components/commands/useCommands";
import { CommandsDirectory } from "@components/commands/lib";
import { useEntities } from "@hooks/useEntities";
import { useViewOnlyRefusal } from "@hooks/permissions/useViewOnlyRefusal";

interface Props {
    selectedTask: Task;
}

const TaskConnectAccountAction = ({ selectedTask }: Props) => {
    const { open } = useCommands();
    const { refuseIfViewOnly } = useViewOnlyRefusal();
    const entities = useEntities();
    const entityId = selectedTask.entityIds?.[0];

    const entity = useMemo(
        () => entities.find((e) => e.id === entityId),
        [entities, entityId],
    );

    if (!entityId) {
        return null;
    }

    const handleClick = () => {
        if (refuseIfViewOnly()) {
            return;
        }
        open(CommandsDirectory.ACCOUNTS, { defaultEntity: entity });
    };

    return (
        <Button onClick={handleClick} variant="primary" size="md">
            Connect account
        </Button>
    );
};

export const ConnectAccountCommandIsland = ({ selectedTask }: Props) => (
    <CommandIsland alignEnd className="mx-3" sticky>
        <TaskConnectAccountAction selectedTask={selectedTask} />
    </CommandIsland>
);
